/*
 * File: RenderOrders.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handle displaying UINotFound and UIProgress for Orders page
 */
import React from "react";
import UINotFound from "components/ui/UINotFound";
import UIProgress from "components/ui/UIProgress";
import Orders from "./Orders";
import PropTypes from "prop-types";
import { PropTypes as MobxPropTypes } from "mobx-react";

const RenderOrders = ({
  orders,
  ordersFetched,
  hasNextPage,
  isNextPageLoading,
  loadNextPage
}) => {
  let renderOrders = () => {
    if (!ordersFetched) return <UIProgress />;
    if (ordersFetched) {
      if (orders.length > 0) {
        return (
          <Orders
            orders={orders}
            hasNextPage={hasNextPage}
            isNextPageLoading={isNextPageLoading}
            loadNextPage={loadNextPage}
          />
        );
      }
      return <UINotFound message="No orders were found" />;
    }
  };

  return <div className="padding">{renderOrders()}</div>;
};

RenderOrders.propTypes = {
  orders: MobxPropTypes.observableArray.isRequired,
  ordersFetched: PropTypes.bool.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  isNextPageLoading: PropTypes.bool.isRequired,
  loadNextPage: PropTypes.func.isRequired
};

export default RenderOrders;
